
































































































































import {ENDPOINTS, get} from '@/api/mainApi';
import validators from '@/validators';
import Vue from 'vue';
import {RequestSession} from "@/interfaces/requestSession";
import {Donation} from "@/interfaces/donation/donation";
import {Type as PaymentType} from "@/interfaces/economy/paymentMethod";
import {DeliveryMethod, Type} from '@/classes/DeliveryMethod';
import {stepV1} from "@/enums/donationStepOrder";
import {PaymentSpecification} from "@/interfaces/economy/paymentSpecification";
import DeliveryMethodSelectComponent from "@/components/DeliveryMethodSelectComponent.vue";
import DonationAmountComponent from "@/components/payment/DonationAmountComponent.vue";
import PaymentMethodSelectComponent from "@/components/payment/PaymentMethodSelectComponent.vue";
import TaxReductionInformationComponent from "@/components/TaxReductionInfoComponent.vue";
import { Intermediary } from '@/interfaces/intermediary/intermediary';
import { isMemoryGift } from '@/classes/DonationType';

const MobileDetect = require('mobile-detect');

    export default Vue.extend({
    components: {
      DeliveryMethodSelectComponent,
      DonationAmountComponent,
      PaymentMethodSelectComponent,
      TaxReductionInformationComponent
    },
    props: {
      value: {
        type: Object,
        default: null,
      },
      showPrev: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        valid: true,
        dialog: false,
        deliveryMethods: [],
        invoiceEmail: '',
        donationDetails: {
          deliveryMethod: null,
          paymentSpecification: {
            paymentMethod: null,
            adminAmount: 0
          } as PaymentSpecification,
          recipient: {
            email: "",
            name: "",
            address: {
              address1: "",
              address2: "",
              address3: "",
              city: "",
              country: "",
              postcode: "",
            },
            isFuneralHome: false,
          },
        } as Donation,
        donationMinAmount: 50,
        donationMaxAmount: 15000,
        mobileNumber: '',
        paymentDeliveryStep: stepV1.PAYMENT_AND_DELIVERY,
        rules: {},
        adminPercentage: null as number | null
      };
    },
    computed: {
      isEmailInvoice() {
        return this.donationDetails.paymentSpecification.paymentMethod && this.donationDetails.paymentSpecification.paymentMethod.type === PaymentType.INVOICE_EMAIL
      },
      isPhoneBased() {
        let md: any = new MobileDetect(window.navigator.userAgent);
        let isMobile = md.mobile() && !md.tablet();

        return this.donationDetails.paymentSpecification && this.donationDetails.paymentSpecification.paymentMethod && this.donationDetails.paymentSpecification.paymentMethod.type === PaymentType.SWISH && !isMobile
          || this.donationDetails.paymentSpecification && this.donationDetails.paymentSpecification.paymentMethod.type === PaymentType.PAYLINK_SMS
      },
      isMailInvoice() {
        return this.donationDetails.paymentSpecification.paymentMethod && this.donationDetails.paymentSpecification.paymentMethod.type === PaymentType.INVOICE_POST
      },
      deliveryIsEmail() {
        return this.donationDetails.deliveryMethod && this.donationDetails.deliveryMethod.type === Type.EMAIL
      },
      isMemoryGift() {
        return this.donation && isMemoryGift(this.donation.donationType.type)
      },
      requestSession(): RequestSession {
        return this.$store.state.requestSession
      },
      donation(): Donation {
        return this.$store.state.donation
      },
      currentStep() {
        return this.$store.state.currentStep
      },
      mobileLabel(): string {
        if (this.donationDetails.paymentSpecification && this.donationDetails.paymentSpecification.paymentMethod && this.donationDetails.paymentSpecification.paymentMethod.type === PaymentType.PAYLINK_SMS) {
          return this.$t('payment.customerMobileForPayLink')
        }
        else {
          if (this.requestSession && (this.requestSession.incomingChannel === 'Bitnet' || this.requestSession.incomingChannel === 'Bitnet - förmedling')) {
            return this.$t('payment.customerMobileForSwish')
          } else {
            return this.$t('payment.yourMobileForSwish')
          }
        }
      },
      totalAmountCalculated() {
        const donationAmount = parseInt(this.donationDetails.paymentSpecification.causeAmount);
        if (
          this.donationMinAmount <= donationAmount &&
          donationAmount <= this.donationMaxAmount
        ) {
          return donationAmount + this.donationDetails.paymentSpecification.adminAmount;
        }
        return null;
      },
      caseRecipientHasDefaultDelivery() {
        return this.donation.donationCase != null && this.donation.donationCase.recipient != null && this.donation.donationCase.recipient.deliveryMethod != null
      },
      caseRecipientNoCertificateHandling() {
        return this.donation.donationCase != null && this.donation.donationCase.recipient != null && this.donation.donationCase.recipient.noCertificateHandling
      }
    },
    watch: {
      isEmailInvoice(val) {
        if (val && (!this.donation.donor.invoiceEmail || this.donation.donor.invoiceEmail.length === 0)) {
          this.invoiceEmail = this.donation.donor.email;
        } else {
          this.invoiceEmail = '';
        }
      },
      invoiceEmail(val) {
        this.donation.donor.invoiceEmail = val;
      },
      mobileNumber(val) {
        this.donation.donor.mobileNumber = val;
      },
      currentStep(val) {
        if (val == stepV1.PAYMENT_AND_DELIVERY) {
          // The order in which these are called is very important! DON'T CHANGE
          this.handlePostOrExternalAgentDeliveryMethod();
          this.setDefaultDeliveryMethod();
          this.handleNoCertificateHandling();

          if (!this.donationDetails.paymentSpecification.paymentMethod) {
            this.donationDetails.paymentSpecification.paymentMethod = this.requestSession.paymentMethods[0]
          }
          this.getAdminFee()
        }
      },
      'donationDetails.paymentSpecification.causeAmount': {
        handler: function (after: number, before: number) {
          if (!!this.adminPercentage && after !== before && after >= this.donationMinAmount && after <= this.donationMaxAmount) {
            this.donationDetails.paymentSpecification.adminAmount = this.donationDetails.paymentSpecification.causeAmount * this.adminPercentage;
          }
        },
      }
    },
    created() {
      // NOTE: This might be an issue if language is to be changed runtime
      Object.assign(this.rules, validators(this.$t('validation')));
    },
    methods: {
      deliveryMethodChanged() {
        // set recipient from donationCase if one is selected or if email is selected -> create a new recipient
        let email = this.caseRecipientHasDefaultDelivery ? this.donation.donationCase.recipient.email : ""
        let name = this.caseRecipientHasDefaultDelivery ? this.donation.donationCase.recipient.name : ""
        let address = this.caseRecipientHasDefaultDelivery ? this.donation.donationCase.recipient.address : {
          address1: "",
          address2: "",
          address3: "",
          city: "",
          country: "",
          postcode: "",
        };

        let isFuneralHome = this.caseRecipientHasDefaultDelivery ? this.donation.donationCase.recipient.isFuneralHome : false

        if (this.caseRecipientHasDefaultDelivery && !this.deliveryIsEmail) {
          this.donationDetails.recipient = this.donation.donationCase.recipient
        } else if (this.deliveryIsEmail) {
          this.donationDetails.recipient = {
            email: email,
            name: name,
            address: {
              address1: "",
              address2: "",
              address3: "",
              city: "",
              country: "",
              postcode: "",
            },
            isFuneralHome: false,
          }
        }
        // then get correct adminFee
        this.getAdminFee()
      },
      async getAdminFee() {
        if (this.donationDetails && this.donationDetails.deliveryMethod && this.donationDetails.paymentSpecification.paymentMethod) {
          const intermediary: Intermediary | null = this.requestSession.intermediary;
          let data = await get(ENDPOINTS.DONATION_CAUSES +
            "/" + this.donation.donationCause.id +
            "/" + ENDPOINTS.DONATION_TYPES +
            "/" + this.donation.donationType.id +
            "/" + ENDPOINTS.ADMIN_FEE,
            {
              deliveryMethodId: this.donationDetails.deliveryMethod.id,
              paymentMethodId: this.donationDetails.paymentSpecification.paymentMethod.id,
              intermediaryId: intermediary ? intermediary.id : null
            });
            if (data) {
              if (!!data.adminAmount) {
                this.donationDetails.paymentSpecification.adminAmount = data.adminAmount;
                this.adminPercentage = null;
                this.donationDetails.paymentSpecification.adminPercentage = null;
              } else {
                this.adminPercentage = data.adminPercentage;
                this.donationDetails.paymentSpecification.adminAmount = this.donationDetails.paymentSpecification.causeAmount * this.adminPercentage;
                this.donationDetails.paymentSpecification.adminPercentage = this.adminPercentage;
              }
            }
        }
      },
      validateDonationAmount(value) {
        const donationAmount = parseInt(value);
        const trueDonationAmount = parseFloat(value);
        if (typeof donationAmount != 'number') {
          return this.$t('validation.numeric');
        } else if (!Number.isInteger(trueDonationAmount)) {
          return this.$t('validation.nonInteger');
        } else if (/^\d+\.\d+$/.test(value)) { // if the value is an integer, but of a bad form (e.g. 10.0)
          return this.$t('validation.hasDecimal');
        } else if (this.donationMaxAmount < donationAmount) {
          return this.$t('validation.maxValue', {max: this.donationMaxAmount});
        } else if (donationAmount < this.donationMinAmount) {
          return this.$t('validation.minValue', {min: this.donationMinAmount});
        }

        return true;
      },
      t(label) {
        const $te = this.$te.bind(this);
        const $t = this.$t.bind(this);
        return $te(label) ? $t(label) : undefined;
      },
      next() {
        if (!this.$refs.form.validate()) {
          // TODO: Break out and reuse for other form steps
          for (var i = 0; i < this.$refs.form.$children.length; i++) {
            const child = this.$refs.form.$children[i];
            if (child.valid === false) {
              this.$vuetify.goTo(child, {offset: 100});
            }
          }
          return;
        }
        let donation: Donation = this.donation;
        donation.deliveryMethod = this.donationDetails.deliveryMethod;
        donation.paymentSpecification = this.donationDetails.paymentSpecification;

        // only when delivery is set to Email should a recipient be created and set for the donation
        if (donation.deliveryMethod?.type === Type.EMAIL) {
          donation.recipient = this.donationDetails.recipient
        } else {
          donation.recipient = null
        }
        donation.paymentSpecification.paymentMethod = this.donationDetails.paymentSpecification.paymentMethod;
        this.$store.commit('updateDonation', donation);

        this.$emit('nextStep');
      },
      handlePostOrExternalAgentDeliveryMethod() {
        let filteredMethods: Array<DeliveryMethod> = this.requestSession.deliveryMethods.slice();
        if (this.isMemoryGift && (!this.requestSession.intermediary || this.requestSession.donationCases && this.requestSession.donationCases.length > 0)) {
          // if there is a recipient set for the case and the recipient has a deliveryMethod with type EXTERNAL_AGENT
          if (this.caseRecipientHasDefaultDelivery && (this.donation.donationCase.recipient.deliveryMethod.type === Type.EXTERNAL_AGENT || this.donation.donationCase.recipient.deliveryMethod.type === Type.PRINT)) {
            // First we remove type POST and EMAIL if it exists in the list
            let postIndex = filteredMethods.findIndex((method) => method.type === Type.POST);
            if (postIndex >= 0) {
              filteredMethods.splice(postIndex, 1)
            }
            let emailIndex = filteredMethods.findIndex((method) => method.type === Type.EMAIL);
            if (emailIndex >= 0) {
              filteredMethods.splice(emailIndex, 1)
            }
            // Then we add type EXTERNAL_AGENT if it doesn't exist
            let externalIndex = filteredMethods.findIndex((method) => method.type === Type.EXTERNAL_AGENT);
            if (externalIndex < 0) {
              filteredMethods.push({
                id: 4,
                type: Type.EXTERNAL_AGENT,
                name: this.$t('payment.deliveryMethod.externalAgent.name'),
                description: this.$t('payment.deliveryMethod.externalAgent.description'),
                nameTranslationKey: 'deliveryMethod.external.name',
                descriptionTranslationKey: 'deliveryMethod.external.description',
                color: "secondary",
                icon: "mdi-hand-heart"
              } as DeliveryMethod)
            }
            // lastly we pre-select first item in the list
            this.donationDetails.deliveryMethod = filteredMethods[0]

          } else if(filteredMethods.length > 1) {
            // otherwise we remove external agent type deliverymethod if it exists and there is another deliverymethod to choose from
            let index = filteredMethods.findIndex((method) => method.type === Type.EXTERNAL_AGENT);
            if (index >= 0) {
              filteredMethods.splice(index, 1)
            }
          }
        }
        this.deliveryMethods = filteredMethods
      },
      handleNoCertificateHandling() {
        let filteredMethods: Array<DeliveryMethod> = this.requestSession.deliveryMethods.slice();
        if (this.isMemoryGift && this.requestSession.donationCases && this.requestSession.donationCases.length > 0) {
          // if there is a recipient set for the case and the recipient has a deliveryMethod with type EXTERNAL_AGENT
          if (this.caseRecipientNoCertificateHandling) {
            // First we remove everything except Email
            filteredMethods = filteredMethods.filter(fm => fm.type === Type.EMAIL);
            // Then we add type Email if it doesn't exist
            let index = filteredMethods.findIndex((method) => method.type === Type.EMAIL);
            if (index < 0) {
              filteredMethods.push({
                id: 1,
                type: Type.EMAIL,
                name: this.$t('payment.deliveryMethod.email.name'),
                description: this.$t('payment.deliveryMethod.email.description'),
                color: "primary",
                icon: "mdi-email-outline"
              } as DeliveryMethod)
            }
          }
        }
      },
      setDefaultDeliveryMethod() {
        // reset deliveryMethod if it is not allowed
        if (this.donationDetails.deliveryMethod) {
          let index = this.deliveryMethods.findIndex((method) => method.type === this.donationDetails.deliveryMethod.type);
          if (index < 0) {
            // set deliveryMethod to null
            this.donationDetails.deliveryMethod = null
          }
        }

        if (this.isMemoryGift && !this.donationDetails.deliveryMethod) {
          // if case recipient has a deliveryMethod that is allowed
          if (this.caseRecipientHasDefaultDelivery) {
            let index = this.deliveryMethods.findIndex((method) => method.type === this.donation.donationCase.recipient.deliveryMethod.type);
            if (index >= 0) {
              // set it as default deliveryMethod
              this.donationDetails.deliveryMethod = this.deliveryMethods[index]
            }
          } else {
            // otherwise, just set the first deliveryMethod in the list
            this.donationDetails.deliveryMethod = this.deliveryMethods[0]
          }
        }

        // Certificate is not handled, so must be email by default (which should be the first and only element among the delivery methods)
        if (this.isMemoryGift && this.requestSession.donationCases && this.requestSession.donationCases.length > 0 && this.caseRecipientNoCertificateHandling)
        {
          this.donationDetails.deliveryMethod = this.deliveryMethods[0];
        }

        this.deliveryMethodChanged()
      }
    },
  });
